import { Box } from '@mui/material';
import React from 'react';

const NoResults = ({ message }) => {
  return (
    <Box className="d-flex justify-content-center align-items-center w-100 my-5">
      {message ? <h5>{message}</h5> : <h5>No Results Found</h5>}
    </Box>
  );
};

export default NoResults;
